import {
  AvailSuppression,
  AvailSuppressionMode,
  MediatailorSessionConfiguration,
  ReportingMode,
} from '../../../model/MediatailorMetadata';

export function getAvailSuppression(availSuppression: AvailSuppression): any {
  const { mode, value } = availSuppression;
  switch (mode) {
    case AvailSuppressionMode.OFF: {
      return {
        mode: 'OFF',
      };
    }
    case AvailSuppressionMode.BEHIND_LIVE_EDGE: {
      return {
        mode: 'BEHIND_LIVE_EDGE',
        value: value,
        fillPolicy: 'FULL_AVAIL_ONLY',
      };
    }
    case AvailSuppressionMode.AFTER_LIVE_EDGE_FULL_AVAIL_ONLY: {
      return {
        mode: 'AFTER_LIVE_EDGE',
        value: value,
        fillPolicy: 'FULL_AVAIL_ONLY',
      };
    }
    case AvailSuppressionMode.AFTER_LIVE_EDGE_PARTIAL_AVAIL: {
      return {
        mode: 'AFTER_LIVE_EDGE',
        value: value,
        fillPolicy: 'PARTIAL_AVAIL',
      };
    }
  }
}

export function getMediaTailorSessionParams(
  mediatailorSessionConfiguration: Partial<MediatailorSessionConfiguration>,
  palNonce?: string,
): { [key: string]: any } {
  const params = mediatailorSessionConfiguration;
  const { originParams, availSuppression, adSignaling, playerParams, ...otherParams } = params as any;
  if (palNonce) {
    playerParams.givn = palNonce;
  }

  return {
    ...otherParams,
    playerParams,
    reportingMode: ReportingMode.SERVER,
    ...(originParams || {}),
    ...(availSuppression && { availSuppression: getAvailSuppression(availSuppression) }),
    ...(adSignaling && { adSignaling: { enabled: 'true' } }),
  };
}

/** MediaTailor HLS tracking data is only generated once the variant playlist is requested. */
export const isHlsManifestUrl = (manifestUrl?: string): boolean => !!manifestUrl?.toLowerCase().includes('.m3u8');
